import { Tags as TagsIcon } from "lucide-react";
import {
  TagsParamsSchema,
  defaultTagsParams,
  type TagsParams,
} from "@playbookai/widget-schemas";
import type { WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { TagsWidget } from "./Component.js";
import { TagsExpandedEditor } from "./ExpandedEditor.js";

export const tagsDef: WidgetDef<TagsParams> = {
  kind: "tags",
  label: "Tags",
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 352, h: 444 },
  defaultParams: defaultTagsParams,
  Component: TagsWidget,
  ExpandedComponent: TagsExpandedEditor,
  expandable: true,
  storage: "sql",
  schema: TagsParamsSchema,
  accent: "purple",
  icon: TagsIcon,
  subtitle: "Trend · Actual · Gap · Standard",
  defaultRoster: true,
  category: "multi",
  layout: { col: 1, row: 0, width: 352, height: 420 },
  renderFooter: () => ({
    left: "",
    right: "Source: this SOLVE",
  }),
};

registerWidget(tagsDef);
